import {Trans} from '@lingui/macro'

import {ListItem, Text} from '@pleo-io/telescope'

import Country from '~/locale/country'

import {CompactList} from './how-trial-works.styles'

export const Perks = ({country, trialLength}: {country: Country; trialLength: Number}) => (
    <>
        <Text as="p" space={10}>
            <Trans>
                Enjoy the best of Pleo with a {trialLength}-day trial of Pleo premium features,
                including:
            </Trans>
        </Text>
        <CompactList listStyle="bullet">
            <ListItem>
                <Trans>Individual spending limits</Trans>
            </ListItem>
            {country === Country.GB && (
                <ListItem>
                    <Trans>More free invoice payments</Trans>
                </ListItem>
            )}
            <ListItem>
                <Trans>Teams and spend approvals</Trans>
            </ListItem>
            <ListItem>
                <Trans>Out-of-pocket, cash & mileage reimbursements</Trans>
            </ListItem>
            <ListItem>
                <Trans>Real-time analytics</Trans>
            </ListItem>
            <ListItem>
                <Trans>... and more</Trans>
            </ListItem>
        </CompactList>
    </>
)
